/**
 * Utility function to check if a given object is empty.
 */
const isEmptyObject = (object: Record<string, any>) =>
  object && Object.keys(object).length === 0;

export default isEmptyObject;
